import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const notificationApiService = createApi({
  reducerPath: "notificationApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    "PendingTemplateUpdates",
    "LearnerNotifications",
    "CreatorNotifications",
  ],
  endpoints: (builder) => ({
    getLearnerNotifications: builder.query({
      query: (params = {}) => ({
        url: `notification/learner${queryParams(params)}`,
        method: "GET",
      }),
      providesTags: ["LearnerNotifications"],
    }),
    markLearnerNotificationRead: builder.mutation({
      query: ({ id, lang, payload }) => ({
        url: `notification/learner/${id}/read${queryParams({ lang })}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: (result, error) =>
        error ? [] : ["LearnerNotifications"],
    }),
    getCreatorNotifications: builder.query({
      query: (params = {}) => ({
        url: `notification/creator${queryParams(params)}`,
        method: "GET",
      }),
      providesTags: ["CreatorNotifications"],
    }),
    markCreatorNotificationRead: builder.mutation({
      query: ({ id, lang, payload }) => ({
        url: `notification/creator/${id}/read${queryParams({ lang })}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: (result, error) =>
        error ? [] : ["CreatorNotifications"],
    }),
    getCourseNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/course/status${query}`,
          method: "GET",
        };
      },
    }),
    getCourseExpiryNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/course/expiry${query}`,
          method: "GET",
        };
      },
    }),
    getTemplateUpdateNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/template-updates${query}`,
          method: "GET",
        };
      },
    }),
    getPendingTemplateUpdateNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/pending/template${query}`,
          method: "GET",
        };
      },
      providesTags: ["PendingTemplateUpdates"],
    }),
    updateNotificationStatus: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `notification/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["PendingTemplateUpdates"],
    }),
    getReportedPostNotifications: builder.query({
      query: ({ params }) => {
        let query = queryParams(params);
        return {
          url: `notification/post-reports${query}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetLearnerNotificationsQuery,
  useMarkLearnerNotificationReadMutation,
  useGetCreatorNotificationsQuery,
  useMarkCreatorNotificationReadMutation,
  useGetCourseNotificationsQuery,
  useGetCourseExpiryNotificationsQuery,
  useGetTemplateUpdateNotificationsQuery,
  useGetPendingTemplateUpdateNotificationsQuery,
  useUpdateNotificationStatusMutation,
  useGetReportedPostNotificationsQuery,
} = notificationApiService;
